module.exports = __webpack_public_path__ + "static/media/2.19.4b57046e.png";